export const GET_PROFILE_DATA_EDIT = 'action/company/profile/get/edit'
export const SAVE_OWN_PROFILE = 'action/company/profile/own/save'
export const INQUIRE_TALENT = 'action/company/inquiry/talent/post'
export const INQUIRE_TALENT_CANCEL = 'action/company/inquiry/talent/delete'
